<template>
  <v-slider
    :value="value"
    v-bind="$attrs"
    hide-details
    track-color="grey300"
    tick-size="4"
    track-fill-color="rgba(255,255,255,.8)"
    @input="$emit('input', $event)"
  >
    <template v-if="valueLabel" #append>
      <div class="value-label">
        {{ valueLabel }}
      </div>
    </template>
  </v-slider>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true,
    },
    valueLabel: {
      type: [Number, String],
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
.v-input__slider ::v-deep {
  .v-input__slot {
    justify-content: space-between;
  }

  .v-slider__track-container,
  .v-slider__ticks-container {
    height: 8px !important;
  }

  .v-slider__tick {
    top: calc(50% - 4px) !important;
    height: 8px !important;
  }

  label {
    color: #cecece;
    text-transform: uppercase;
  }

  label + .v-slider {
    max-width: 220px;
  }

  .v-slider__thumb {
    height: 28px;
    border: 2px solid #cecece !important;
    border-radius: 0;

    &::before {
      display: none;
    }
  }

  .v-input__append-outer {
    align-self: stretch;
    align-items: center;
  }

  .value-label {
    width: 35px;
  }
}

</style>
